const libPictViewClass = require('pict-view');

/**
 * FIXME: figure out how to flow these types through in a more sane way...
 * @typedef {import('pict') & import('fable') &
 * {
 *   HeadlightRestClient: import('headlight-rest-client'),
 *   MetaTemplate: any, // import('fable').MetaTemplate,
 *   views: { PictFormMetacontroller: import('pict-section-form').PictFormMetacontroller },
 *   fable: import('fable'),
 * }} Pict
 */

/** @typedef {import('fable')} Fable */
/** @typedef {(pError?: (Error | String)) => void} HybridErrorCallback */

/**
 * Pict Login view.
 */
class HeadlightLogin extends libPictViewClass
{
	/**
	 * @param {import('fable')} pFable - The fable instance.
	 * @param {any} [pOptions] - The view options.
	 * @param {any} [pServiceHash] - The fable service instance hash.
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/**
		 * FIXME: figure out how to flow these types through in a more sane way...
		 * @type {import('pict') & import('fable') &
		 * {
		 *   MetaTemplate: any, // import('fable').MetaTemplate,
		 *   views: { PictFormMetacontroller: any },
		 *   fable: import('fable'),
		 *   TransactionTracking: any, //FIXME: correct type
		 *   PictApplication: import('pict-application') & {
		 *     onBeforeLogin?: () => Promise<void>,
		 *     onBeforeLogout?: () => Promise<void>,
		 *     onInteractiveLogin?: () => Promise<void>,
		 *     onInteractiveLogout?: () => Promise<void>,
		 *     onAfterInteractiveLogin?: () => Promise<void>,
		 *   },
		 *   RestClient: any,
		 * }}
		 */
		this.pict;

		/** @type {Fable} */
		this.fable;

		/** @type {any} */
		this.options;
	}

	/**
	 * Handle view initialization.
	 *
	 * TODO: consider pre-populating the username if user selected 'Remember Me'
	 */
	onInitialize()
	{
		this.LoginUserName = '';
		this.LoginPassword = '';
		this.LoginTitle = '';
		this.LoginTitleStyles = '';
		this.LoginWallpaperStyles = 'background-color: var(--bulma-grey-darker);';
		this.LoginWallpaperImageList = [];
		this.LoginWallpaperImageListDuration = 5000;
		return super.onInitialize();
	}

	/**
	 * A method to pass in custom styles to the login modal.
	 * @param {Object} pOptions 
	 */
	customizeLoginPage(pOptions)
	{
		this.LoginTitle = pOptions?.title;
		this.LoginTitleStyles = pOptions?.titleStyles;
		this.LoginWallpaperStyles = pOptions?.wallpaperStyles;
		this.LoginWallpaperImageList = pOptions?.wallpaperImageList;

		this.renderAsync(null, null, null, () =>
		{
			this.pict.log.info('Customized login page with title and wallpaper');
		});
	}

	/**
	 * A method to pass in custom styles to the login modal.
	 * @param {Object} pOptions
	 */
	customizeLogoutPage(pOptions)
	{
		this.LoginTitle = pOptions?.title;
		this.LoginTitleStyles = pOptions?.titleStyles;
		this.LoginWallpaperStyles = pOptions?.wallpaperStyles;
		this.LoginWallpaperImageList = pOptions?.wallpaperImageList;
		if (pOptions?.closePanelsOnLogout)
		{
			this.pict.views.HeadlightPanels.closeAllPanels();
		}
		this.show();
	}

	/**
	 * Show the login view.
	 */
	show()
	{
		this.render();
		this.pict.ContentAssignment.addClass(this.options.DefaultDestinationAddress, 'active');
		this.pict.ContentAssignment.removeClass(this.options.DefaultDestinationAddress, 'is-hidden');
	}

	/**
	 * Show the result of a login attempt.
	 *
	 * @param {string} [pMessageType] - The type of message to show.
	 */
	handleLoginMessages(pMessageType)
	{
		// clear all messages first
		this.pict.ContentAssignment.addClass('#Login_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Success', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container-Invalid', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container-Failed', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container-Reset', 'is-hidden');

		// then turn on the type we passed
		if (pMessageType === 'login-error')
		{
			this.pict.ContentAssignment.removeClass('#Login_Error', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#Close-ForgotPassword-Container-Invalid', 'is-hidden');
		}
		else if (pMessageType === 'password-reset-success')
		{
			this.pict.ContentAssignment.removeClass('#PasswordReset_Success', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#Close-ForgotPassword-Container-Reset', 'is-hidden');
		}
		else if (pMessageType === 'password-reset-error')
		{
			this.pict.ContentAssignment.removeClass('#PasswordReset_Error', 'is-hidden');
			this.pict.ContentAssignment.removeClass('#Close-ForgotPassword-Container-Failed', 'is-hidden');
		}
		else
		{
			// do nothing for now - can be for additional statuses
		}
	}

	get loggedInStatus()
	{
		if (!this.AppData.hasOwnProperty('CurrentUser'))
		{
			return false;
		}
		if (!this.AppData.CurrentUser.hasOwnProperty('LoggedIn'))
		{
			return false;
		}
		return (this.AppData.CurrentUser.LoggedIn);
	}

	/**
	 * Check if the user is authenticated.
	 *
	 * @param {(pError: (Error | String | null), pSuccess: Boolean) => void} callback - error-first callback to notify on loggedin status (error, true|false)
	 */
	isUserLoggedIn(callback)
	{
		this.pict.RestClient.getJSON('/1.0/CheckSession', (pError, pResponse, pBody) =>
		{
			if (pError || !pBody.LoggedIn)
			{
				// this.AppData.CurrentUser = undefined;
				if (pError)
				{
					this.pict.log.error(`session check failed: ${pError.message || pError}`, { Stack: pError.stack, Response: pBody });
				}
				else
				{
					this.pict.log.trace('user not logged in, no session found', { Response: pBody });
				}
				callback(null, false);
				return;
			}
			// already logged in
			this.AppData.CurrentUser = pBody;
			callback(null, true);
		});
	}

	/**
	 * Handle the login form submission.
	 *
	 * @param {UIEvent} event - The event that triggered the login.
	 */
	login(event)
	{
		if (typeof (this.pict.PictApplication.onBeforeLogin) === 'function')
		{
			this.pict.PictApplication.onBeforeLogin();
		}
		// prevent the standard page refresh on a form > submit action
		event.preventDefault();

		const tmpHeadlightAuthenticateBody = (
			{
				UserName: this.pict.ContentAssignment.readContent('#Headlight_LoginID'),
				Password: this.pict.ContentAssignment.readContent('#Headlight_Password')
			});

		const tmpAuthenticateRequestOptions = (
			{
				url: '/1.0/Authenticate',
				body: tmpHeadlightAuthenticateBody
			});

		this.pict.RestClient.postJSON(tmpAuthenticateRequestOptions,
			(pError, pResponse, pBody) =>
			{
				if (pError || !pBody || !pBody.LoggedIn)
				{
					this.pict.log.error(`authentication failed: ${pError}`, pError);
					this.handleLoginMessages('login-error');

					return;
				}
				this.AppData.CurrentUser = pBody;
				this.pict.ContentAssignment.removeClass(this.options.DefaultDestinationAddress, 'is-active');
				this.pict.ContentAssignment.addClass(this.options.DefaultDestinationAddress, 'is-hidden');
				this.pict.log.info(`Authenticated: `, pBody);

				// hide modal after login
				this.pict.ContentAssignment.removeClass('#LoginModal', 'is-active');
				// clear out any messages in the modal
				this.handleLoginMessages();

				if (typeof this.pict.PictApplication.loginAsync === 'function')
				{
					this.pict.PictApplication.loginAsync((pError) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error in Application loginAsync: ${pError.message || pError}`, { Stack: pError.stack });
						}
						else
						{
							this.pict.log.info(`Application loginAsync completed successfully`);
						}
					});
				}
				if (typeof (this.pict.PictApplication.onInteractiveLogin) === 'function')
				{
					const res = this.pict.PictApplication.onInteractiveLogin();
					if (res && res.then && res.catch) // Promise duck typing - this is sucky, formalize this better
					{
						// just ensure we don't crash the app if the promise fails
						res.catch((pError) =>
						{
							this.pict.log.error(`Error in Application's onInteractiveLogin: ${pError.message || pError}`, { Stack: pError.stack });
						});
					}
				}
			});
	}

	/**
	 * Lifecycle event after the view renders.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable object.
	 */
	onAfterRender(pRenderable)
	{
		const eventBindings = document.querySelectorAll(pRenderable.ContentDestinationAddress + ' *[data-event-bind]');
		for (let elem of eventBindings)
		{
			const [ event, handler ] = (elem.getAttribute('data-event-bind') || '').split(':');

			if (!event)
			{
				this.pict.log.error('No event specified for event binding for element', elem);
				continue;
			}

			const handlerFn = this[handler];

			if (!handlerFn)
			{
				this.pict.log.error('No handler function found for event binding for element', elem);
				continue;
			}

			elem.addEventListener(event, handlerFn.bind(this));
		}
		// handle the login wallpaper image list transitions if a list is provided
		this.handleImageListTransistions();

		return super.onAfterRender(pRenderable);
	}

	/**
	 * @param {UIEvent} event - the event that triggered the logout
	 */
	logout(event)
	{
		if (typeof this.pict.PictApplication.onBeforeLogout === 'function')
		{
			this.pict.PictApplication.onBeforeLogout();
		}
		this.pict.RestClient.getJSON('/1.0/Deauthenticate', (pError, pResponse, pBody) =>
		{
			if (pError || !pBody || !pBody.Success)
			{
				this.pict.log.error(`Problem logging out: ${pError.message || pError}`, { Stack: pError.stack, Response: pBody });
				return;
			}

			this.pict.log.info(`Logged out successfully.`,{ Response: pBody });
			if (typeof this.pict.PictApplication.loginAsync === 'function')
			{
				this.pict.PictApplication.loginAsync((pError) =>
				{
					if (pError)
					{
						this.pict.log.error(`Error in Application loginAsync: ${pError.message || pError}`, { Stack: pError.stack });
					}
					else
					{
						this.pict.log.info(`Application loginAsync completed successfully`);
					}
				});
			}
			if (typeof (this.pict.PictApplication.onInteractiveLogout) === 'function')
			{
				// TODO: should we call this even if logout failed?
				const res = this.pict.PictApplication.onInteractiveLogout();
				if (res && res.then && res.catch) // Promise duck typing - this is sucky, formalize this better
				{
					// just ensure we don't crash the app if the promise fails
					res.catch((pError) =>
					{
						this.pict.log.error(`Error in Application onInteractiveLogout: ${pError.message || pError}`, { Stack: pError.stack });
					});
				}
			}
		});
	}

	/**
	 * Handle the image list transitions for the login wallpaper.
	 * @spec get the list of images from the context and set the background image to the element for 5 seconds, then fade/transition to the next image, in a loop
	 * @return {void}
	 */
	handleImageListTransistions()
	{
		let nextIndex = 1;
		// get the list of images from the context
		// for each image in the list, set the background image to the element for 5 seconds, then fade/transition to the next image, in a loop
		if (this.LoginWallpaperImageList && this.LoginWallpaperImageList.length > 0)
		{
			const imageElement = document.getElementById('LoginModal-Wallpaper');
			if (imageElement)
			{
				// set the initial transition effects
				imageElement.style.backgroundSize = 'cover';
				imageElement.style.backgroundPosition = 'center';
				imageElement.style.transition = 'background-image 1s ease-in-out';
				// set the next image after 5 seconds
				setInterval(() =>
				{
					// set the current image to the next image
					imageElement.style.backgroundImage = `url(${this.LoginWallpaperImageList[nextIndex]})`;
					// set the next index to the next index + 1, or 0 if it is at the end of the list
					nextIndex = (nextIndex + 1) % this.LoginWallpaperImageList.length;
				}, this.LoginWallpaperImageListDuration || 5000);
			}
			else
			{
				this.pict.log.warn('Unable to find additional image elements for wallpaper transition');
			}
		}
		else
		{
			this.pict.log.info('No additional images found for wallpaper transition');
		}
	}

	/**
	 * @spec abstraction of document object manipulation to check the 'type' attribute of the password input field
	 * @return {boolean} value of " 'type' of the password input field is 'password' "
	 */
	isPasswordFieldProtected()
	{
		return document.getElementById('Headlight_Password').getAttribute('type') === 'password';
	}

	/**
	 * Toggle the password visibility when the user clicks on the eye icon
	 */
	togglePasswordInput()
	{
		if (this.isPasswordFieldProtected())
		{
			this.pict.ContentAssignment.addClass('#Password-Toggle-Icon', 'fa-eye');
			this.pict.ContentAssignment.removeClass('#Password-Toggle-Icon', 'fa-eye-slash');
			document.getElementById('Headlight_Password').setAttribute('type', 'text');
		}
		else
		{
			this.pict.ContentAssignment.removeClass('#Password-Toggle-Icon', 'fa-eye');
			this.pict.ContentAssignment.addClass('#Password-Toggle-Icon', 'fa-eye-slash');
			document.getElementById('Headlight_Password').setAttribute('type', 'password');
		}
	}

	/**
	 * @spec take the current 'username' value and trigger a "reset password" email if the user has a match
	 */
	handleForgotPassword()
	{
		const loginName = this.pict.ContentAssignment.readContent('#Headlight_LoginID');
		const formElement = this.pict.ContentAssignment.getElement('form');
		// prompt the user to enter a user name as it can not be empty to do a reset password
		if ((formElement && formElement.length) && !loginName)
		{
			formElement[0].reportValidity();
			return;
		}
		this.pict.RestClient.getJSON('/1.0/User/ForgotPassword/' + loginName, (pError, pResponse, pBody) =>
		{
			if (pError || !pBody || !pBody.Success)
			{
				this.pict.log.error(`Problem with password recovery request for ${loginName}: ${pError?.message || pError}`, { Stack: pError?.stack, Response: pBody });
				this.handleLoginMessages('password-reset-error');
			}
			else
			{
				this.pict.log.info(`Successfully generated a reset password email for login name '${loginName}': ${pBody.length} `, { Response: pBody });
				this.handleLoginMessages('password-reset-success');
			}
		});
	}

	closeForgotPasswordMessage()
	{
		this.pict.ContentAssignment.addClass('#Login_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Success', 'is-hidden');
		this.pict.ContentAssignment.addClass('#PasswordReset_Error', 'is-hidden');
		this.pict.ContentAssignment.addClass('#Close-ForgotPassword-Container', 'is-hidden');
	}
}

module.exports = HeadlightLogin;

module.exports.default_configuration = (
{
	ViewIdentifier: "HeadlightLogin",
	RenderOnLoad: false,
	AutoRender: false,
	DefaultRenderable: "HeadlightLogin-Standard",
	DefaultDestinationAddress: "#HeadlightLogin-Standard-Wrap",
	CSS: /*css*/ ``,
	Templates: [
		{
			Hash: "HeadlightLogin-Standard-Wrap",
			Template: /*html*/`
			<section id="HeadlightLogin-Standard-Wrap">
				{~T:HeadlightLogin-Standard-MaterialDesign~}
			</section>
			`			
		},
		{
			Hash: "HeadlightLogin-Standard-MaterialDesign",
			Template: /*html*/`
			<div class="modal is-active" id="LoginModal">
			  	<div id="LoginModal-Wallpaper" class="modal-background" style="{~D:Context[0].LoginWallpaperStyles~}"></div>
				<h1 id="LoginModal-Title" class="title is-size-1 has-text-white px-2" style="{~D:Context[0].LoginTitleStyles~}">{~D:Context[0].LoginTitle~}</h1>
				<form role="login-form" data-event-bind="submit:login">
					<div class="modal-content">
						<div class="box pt-0 pr-6 pb-6 pl-6">
							<div class="container has-text-centered">
								<img src="./images/hashes.png" width="350px" alt="color-hashes" />
							</div>
							<div class="container has-text-centered my-5">
								<img src="./images/HeadLight-logo_gray.png" width="300px" alt="HeadLight" />
							</div>
							<div class="field">
								<p class="control has-icons-left">
									<input id="Headlight_LoginID" required class="input" type="text" name="username" placeholder="Username" value="{~D:Context[0].LoginUserName~}">
									<span class="icon is-small is-left">
										<i class="fas fa-user"></i>
									</span>
								</p>
							</div>
							<div class="field">
								<p class="control has-icons-left has-icons-right">
									<input id="Headlight_Password" required class="input" name="password" type="password" role="input-password" autocomplete="current-password" placeholder="Password" value="{~D:Context[0].LoginPassword~}">
									<span class="icon is-small is-left">
										<i class="fas fa-lock"></i>
									</span>
									<span class="icon is-small is-right is-clickable" data-event-bind="click:togglePasswordInput">
										<i id="Password-Toggle-Icon" class="fas fa-eye-slash"></i>
									</span>
								</p>
							</div>
							<div class="container has-text-centered">
								<div id="Login_Error" class="notification is-hidden is-danger is-soft mb-2">
									<button id="Close-ForgotPassword-Container-Invalid" type="button" class="delete is-hidden" data-event-bind="click:closeForgotPasswordMessage"></button>
									<i class="fas fa-exclamation-circle mr-1"></i>
										Invalid username or password
								</div>
								<div id="PasswordReset_Error" class="notification is-hidden is-danger is-soft mb-2">
									<button id="Close-ForgotPassword-Container-Failed" type="button" class="delete is-hidden" data-event-bind="click:closeForgotPasswordMessage"></button>
									<i class="fas fa-exclamation-circle mr-1"></i>
										Password recovery failed
								</div>
								<div id="PasswordReset_Success" class="notification is-hidden is-warning is-soft mb-2">
									<button id="Close-ForgotPassword-Container-Reset" type="button" class="delete is-hidden" data-event-bind="click:closeForgotPasswordMessage"></button>
										If an account is associated with this username, then password recovery instructions have been sent to the connected email.
								</div>
							</div>
							<div class="columns">
								<div class="column">							
									<button id="Login-ForgotPassword-Button" type="button" class="button is-ghost" data-event-bind="click:handleForgotPassword">Forgot Password?</button>
								</div>
								<div class="column">
									<div class="buttons is-right">
										<button type="submit" class="button is-link">Login</button>
									</div>
								</div>
							</div>
						</div>
						<div class="container has-text-centered has-text-white is-size-7">By clicking Login you are agreeing to our <a target="_blank" class="link has-text-warning" href="https://fieldbook.qa.headlight.com/Assets/templates/terms-of-service.html">Terms and Conditions</a>.</div>
					</div>
				</form>
			</div>`
		}
	],
	Renderables: [
		{
			RenderableHash: "HeadlightLogin-Standard",
			TemplateHash: "HeadlightLogin-Standard-MaterialDesign",
			DestinationAddress: "#HeadlightLogin-Standard-Wrap"
		}
	]
});
